import { openWhatsApp, WA_MESSAGES } from "@/components/Cta";

export default function CoopNote({ variant = "full", title, body, cta, location, testId = "coop-note", divider = false }) {
  const handle = () => openWhatsApp(location, { text: cta, message: WA_MESSAGES.dropshipping });
  return (
    <div className={divider ? "border-b border-ink/10 pb-8 mb-8" : ""} data-testid={testId}>
      <p className={`flex items-center justify-center gap-2 font-bold text-forest ${variant === "full" ? "text-base md:text-lg" : "text-sm md:text-base"}`}>
        <span className="h-1.5 w-1.5 rounded-full bg-lime" />
        {title}
      </p>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-ink/60">{body}</p>
      <button
        onClick={handle}
        className="mt-3 text-sm font-semibold text-forest underline-offset-4 transition-colors hover:text-ink hover:underline"
        data-testid={`${testId}-cta`}
        data-location={location}
      >
        {cta} →
      </button>
    </div>
  );
}
